import {useState, useEffect} from 'react';
import {AxiosResponse} from 'axios';
import BusinessStats from '../apis/BusinessStats';

export interface FetchBusinessStatsResponse {
  stats: Stats;
}

interface Stats {
  ukFundedAmount?: string;
  nlFundedAmount?: string;
  fundedCustomers?: string;
  totalFunding?: string;
}

const roundToNearestMillion = (value: number): number => Math.round(value / 1000000);

const useFetchBusinessData = (): FetchBusinessStatsResponse => {
  const [stats, setStats] = useState<Stats>({
    ukFundedAmount: undefined,
    nlFundedAmount: undefined,
    fundedCustomers: undefined,
    totalFunding: undefined,
  });

  useEffect(() => {
    BusinessStats.get()
      .then((getBusinessStatsApiResponse: AxiosResponse) => {
        const {
          uk_funded_amount: ukFundedAmount,
          nl_funded_amount: nlFundedAmount,
          funded_customers: fundedCustomers,
        } = getBusinessStatsApiResponse.data;

        setStats({
          ukFundedAmount: ukFundedAmount.toString(),
          nlFundedAmount: nlFundedAmount.toString(),
          fundedCustomers: fundedCustomers.toString(),
          totalFunding: roundToNearestMillion(nlFundedAmount + ukFundedAmount).toString(),
        });
      })
      .catch(() => null);
  }, []);

  return {
    stats,
  };
};

export default useFetchBusinessData;
